<div class="dx-dropzone" (click)="onTriggerBrowse()">
  <input
    #fileInput
    class="dx-dropzone-input"
    type="file"
    [accept]="accept"
    (change)="onNativeFileChange($event)"
  />

  <ng-container *ngIf="!selectedFile; else selectedState">
    <i class="pi pi-upload dx-dropzone-icon"></i>
    <div class="dx-dropzone-text">
      <span class="dx-dropzone-link">Click to browse</span> or drag &amp; drop
    </div>
    <div class="dx-dropzone-meta">{{ hint }}</div>
  </ng-container>

  <ng-template #selectedState>
    <ng-container *ngIf="uploadProgress !== null; else normalSelectedState">
      <div class="dx-dropzone-uploading-body">
        <div class="dx-dropzone-upload-row dx-dropzone-upload-row--top">
          <i class="pi pi-file dx-dropzone-upload-icon"></i>
          <div class="dx-dropzone-upload-name">{{ selectedFile?.name }}</div>
          <span class="dx-dropzone-upload-pct">{{ uploadProgress }}%</span>
        </div>
        <div class="dx-dropzone-upload-row dx-dropzone-upload-row--sub">
          {{ formatSize(selectedFile?.size) }} &middot; Uploading...
        </div>
        <div class="dx-dropzone-progress-track">
          <div class="dx-dropzone-progress-fill" [style.width.%]="uploadProgress"></div>
        </div>
      </div>
    </ng-container>

    <ng-template #normalSelectedState>
      <div class="dx-dropzone-selected">
        <div class="dx-dropzone-selected-main">
          <div class="dx-dropzone-selected-top">
            <i class="pi pi-check-circle dx-dropzone-selected-check"></i>
            <div class="dx-dropzone-selected-name">{{ selectedFile?.name }}</div>
          </div>
          <div class="dx-dropzone-selected-sub">
            {{ formatSize(selectedFile?.size) }}
          </div>
        </div>
        <button
          pButton
          pRipple
          type="button"
          class="p-button-text p-button-sm"
          icon="pi pi-times"
          (click)="$event.stopPropagation(); clear()"
          aria-label="Remove file"
        ></button>
      </div>
    </ng-template>
  </ng-template>
</div>
